<template>
  <PurchaseTable query-type="wait_receive"></PurchaseTable>
</template>

<script>
import PurchaseTable from '@/views/modules/erp/client/common/purchase/purchase-table.vue'

export default {
  mixins: [],
  components: { PurchaseTable },
  data () {
    return {}
  },
  methods: {}
}
</script>
